import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchApyDetails } from './fetchApyDetails.api';

export const useGetApyDetails = () =>
  useSuspenseQuery({
    queryKey: ['apyDetails'],
    queryFn: fetchApyDetails,
    staleTime: Infinity,
  });
